import { useGetMemberTemplateCategories } from '@/shared/api/client/customer-category-controller';

/**
 * Hook to fetch member template categories (sub-parts) for hierarchical customer category forms
 * These are the templates that Groups/Businesses can select to define their member structure
 */
export const useMemberTemplateCategories = () => {
    const {
        data: memberTemplateCategories,
        isLoading,
        error,
        refetch
    } = useGetMemberTemplateCategories();

    return {
        memberTemplateCategories: Array.isArray(memberTemplateCategories) ? memberTemplateCategories : [],
        isLoading,
        error,
        refetch
    };
};
